module.exports = __webpack_public_path__ + "static/media/15_l_Layer6_6.67_1.2.040c7d97.png";